export const SEARCH = 'search';
export const CART = 'cart';
export const INCREMENT = 'increment';
export const DECREMENT = 'decrement';
export const REMOVE = 'remove';
export const EMPTY = 'empty';
export const NAME ='name';
